import { render, staticRenderFns } from "./FileInputBase64.vue?vue&type=template&id=2d3bdf9c&"
import script from "./FileInputBase64.vue?vue&type=script&lang=js&"
export * from "./FileInputBase64.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports